import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRequestService } from '@/composables/services'
import { useAccountStore } from '@/stores/account'
import { getRequestSource } from './contact-form.helpers'
import type { ContactFormData } from './contact-form.types'

export interface UseContactFormSharedOptions {
  showRegion?: boolean
}

export function useContactFormShared(options: UseContactFormSharedOptions = {}) {
  const { showRegion: showRegionProp = false } = options
  const { account } = storeToRefs(useAccountStore())
  const requestService = useRequestService()
  const accountStore = useAccountStore()

  const config = computed(() => account.value?.account_config_landing)
  const showRegion = computed(() => config.value?.form_regions_field_enabled ?? showRegionProp)

  const submitToApi = async (data: ContactFormData) => {
    const accountId = accountStore.account?._id
    if (!accountId) throw new Error('accountId is required to create request')
    await requestService.createRequestFromContactForm(data, accountId, getRequestSource())
  }

  return { showRegion, submitToApi }
}
